import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  fill: "currentColor",
  stroke: "none"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_29367_61269)"><path opacity="0.2" d="M9.99573 2.61719L2.21875 9.50693V15.7466C2.21875 16.9892 3.21368 17.9966 4.44097 17.9966H15.5511C16.7783 17.9966 17.7733 16.9892 17.7733 15.7466V9.50746L9.99573 2.61719Z"></path><path d="M19.6208 8.15302L17.7776 6.52018V1.68694C17.7776 1.37658 17.5291 1.12444 17.222 1.12444H14.9999C14.6929 1.12444 14.4444 1.37658 14.4444 1.68694V3.56741L10.7319 0.278508C10.5225 0.0928476 10.2612 0 10 0C9.73878 0 9.47753 0.0928476 9.26812 0.278508L0.379236 8.15302C0.0922222 8.40779 0 8.74136 0 9.00028C0 9.85359 0.763507 10.1249 1.11111 10.125C1.37073 10.125 1.6316 10.0335 1.84299 9.84699L10 2.62058L18.157 9.84699C18.3681 10.0337 18.629 10.1249 18.8883 10.1249C19.23 10.1249 20 9.85338 20 9.00028C20 8.74086 19.9073 8.40734 19.6208 8.15302Z"></path></g><defs><clipPath id="clip0_29367_61269"><rect width="20" height="18" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const HouseBlankDuotoneIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  HouseBlankDuotoneIcon as default
};
//# sourceMappingURL=HouseBlankDuotoneIcon.vue.es.js.map
